import { Button, Col, Form, Input, Row, TimePicker } from "antd";
import React from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const ShiftCompany = ({ edit }) => {
  return (
    <>
      <Form.List name="company_shifts">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row gutter={10} key={key}>
                <Col xl={10}>
                  <Form.Item
                    {...restField}
                    name={[name, "name"]}
                    label={`Shift ${name + 1}`}
                    rules={[
                      { required: true, message: "Shift name is required" },
                    ]}
                  >
                    <Input placeholder="Shift Name" disabled={edit} />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "start"]}
                    label={" "}
                    rules={[
                      { required: true, message: "Start time is required" },
                    ]}
                  >
                    <TimePicker
                      className="w-full"
                      placeholder="Start Time"
                      format={"HH:mm"}
                      minuteStep={15}
                      disabled={edit}
                    />
                  </Form.Item>
                </Col>
                <Col xl={6}>
                  <Form.Item
                    {...restField}
                    name={[name, "end"]}
                    label={"End Time"}
                    rules={[
                      { required: true, message: "Please Input End Time" },
                    ]}
                  >
                    <TimePicker
                      className="w-full"
                      placeholder="End Time"
                      format={"HH:mm"}
                      minuteStep={15}
                      disabled={edit}
                    />
                  </Form.Item>
                </Col>
                <Col xs={2} className="pt-8 pl-8">
                  {fields.length > 1 && !edit && (
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  )}
                </Col>
              </Row>
            ))}
            <Row>
              {!edit && (
                <Col xl={6}>
                  <Form.Item className="mt-1">
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Shift
                    </Button>
                  </Form.Item>
                </Col>
              )}
            </Row>
          </>
        )}
      </Form.List>
    </>
  );
};

export default ShiftCompany;
